(() => {
  const media = window.matchMedia('(max-width: 749px)');
  const colorMap = [
    ['graphite heather', '#55565a'], ['dark heather', '#4b4b4d'],
    ['heather navy', '#31445d'], ['heather royal', '#416aa3'],
    ['sport grey', '#a9aaad'], ['ash', '#c7c7c5'], ['charcoal', '#45484c'],
    ['black', '#111111'], ['white', '#f6f4ee'], ['navy', '#18263f'],
    ['royal', '#2458a6'], ['light blue', '#9fc7df'], ['jade dome', '#568f86'],
    ['military green', '#596447'], ['forest green', '#244d35'],
    ['irish green', '#2c9b58'], ['maroon', '#6e2939'], ['red', '#c9353e'],
    ['orange', '#dc6d2d'], ['yellow', '#e4c84b'], ['purple', '#68477f'],
    ['pink', '#d99aab'], ['sand', '#c8b596'], ['natural', '#ded2bb'],
    ['brown', '#6c4939'], ['grey', '#888b8e'], ['gray', '#888b8e'],
    ['blue', '#537eae'], ['green', '#4f7656']
  ];

  const clean = value => value.replace(/\s*-\s*(sold out|unavailable).*$/i, '').trim();
  const selectedText = select => clean(select.options[select.selectedIndex]?.text || '');
  const swatchFor = value => {
    const v = value.toLowerCase().trim();
    return (colorMap.find(([name]) => v.includes(name)) || [null, '#777b82'])[1];
  };

  function enhanceOption(wrapper) {
    if (!media.matches || wrapper.classList.contains('gpt-mobile-enhanced')) return;
    const select = wrapper.querySelector('select');
    if (!select) return;

    const sourceLabel = wrapper.querySelector('label');
    const label = (sourceLabel?.textContent || select.name || 'Option').replace(/:.*$/, '').trim();
    const isColor = /colou?r/i.test(label);
    const isSize = /size/i.test(label);

    const block = document.createElement('div');
    block.className = `gpt-mobile-variant${isColor ? ' gpt-mobile-color' : ''}${isSize ? ' gpt-mobile-size' : ''}`;
    const heading = document.createElement('div');
    heading.className = 'gpt-mobile-variant-heading';
    const strong = document.createElement('strong');
    strong.textContent = `${label}:`;
    const current = document.createElement('span');
    current.className = 'gpt-mobile-current-value';
    current.textContent = selectedText(select);
    heading.append(strong, current);

    if (isSize) {
      const chart = document.querySelector('[class*="ai-size-chart-trigger-wrapper-"]');
      if (chart) heading.append(chart);
    }

    const buttons = document.createElement('div');
    buttons.className = 'gpt-mobile-variant-buttons';
    buttons.setAttribute('role', 'group');
    buttons.setAttribute('aria-label', label);

    [...select.options].forEach(option => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `gpt-mobile-variant-button${isColor ? ' gpt-mobile-color-button' : ''}`;
      button.dataset.value = option.value;
      button.textContent = clean(option.text);
      button.title = button.textContent;
      button.setAttribute('aria-label', `${label} ${button.textContent}`);
      button.disabled = option.disabled;
      if (isColor) button.style.setProperty('--gpt-swatch', swatchFor(button.textContent));
      button.addEventListener('click', () => {
        if (button.disabled) return;
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        requestAnimationFrame(sync);
      });
      buttons.append(button);
    });

    const sync = () => {
      current.textContent = selectedText(select);
      buttons.querySelectorAll('button').forEach(button => {
        const chosen = button.dataset.value === select.value;
        button.classList.toggle('is-selected', chosen);
        button.setAttribute('aria-pressed', chosen ? 'true' : 'false');
      });
    };
    select.addEventListener('change', sync);
    block.append(heading, buttons);
    wrapper.insertBefore(block, wrapper.firstChild);
    wrapper.classList.add('gpt-mobile-enhanced');
    sync();
  }

  function moveReview(details) {
    if (details.querySelector('.gpt-mobile-review-badge')) return;
    const badge = document.querySelector('.jdgm-prev-badge, .jdgm-preview-badge');
    if (!badge) return;
    badge.classList.add('gpt-mobile-review-badge');
    (details.querySelector('.group-block') || details).prepend(badge);
  }

  function addPriceDetails(details) {
    const priceBlock = details.querySelector('product-price') || details.querySelector('.price')?.parentElement;
    if (!priceBlock) return;
    const compare = priceBlock.querySelector('.compare-at-price, s, del');
    if (compare?.textContent.trim() && !priceBlock.querySelector('.gpt-sale-badge')) {
      const badge = document.createElement('span');
      badge.className = 'gpt-sale-badge';
      badge.textContent = 'Sale';
      (priceBlock.querySelector('.price') || priceBlock).append(badge);
    }
    if (!priceBlock.parentElement?.querySelector(':scope > .gpt-shipping-note')) {
      const note = document.createElement('div');
      note.className = 'gpt-shipping-note';
      note.textContent = 'Shipping calculated at checkout.';
      priceBlock.insertAdjacentElement('afterend', note);
    }
  }

  function moveAfterpay(details) {
    const buy = details.querySelector('.buy-buttons-block');
    const placement = details.querySelector('afterpay-placement, square-placement, [data-afterpay-placement]');
    if (!buy || !placement) return;
    const app = placement.closest('.shopify-block, [id^="shopify-block-"], .app-block') || placement.parentElement || placement;
    if (app.classList.contains('gpt-afterpay-moved')) return;
    app.classList.add('gpt-afterpay-moved');
    buy.insertAdjacentElement('afterend', app);
  }

  function addTrust(details) {
    const buy = details.querySelector('.buy-buttons-block');
    if (!buy || details.querySelector('.gpt-trust-line')) return;
    const line = document.createElement('div');
    line.className = 'gpt-trust-line';
    line.textContent = 'Original Australian ink-sketch tees · Printed to order';
    buy.insertAdjacentElement('afterend', line);
  }

  function currentPrice(details) {
    const candidates = [
      '.price__sale .money', '.price__regular .money',
      'product-price .price__sale', 'product-price .price__regular',
      'product-price .money', '.price .money'
    ];
    for (const selector of candidates) {
      const text = details.querySelector(selector)?.textContent?.trim();
      const match = text?.match(/\$\s?[0-9,.]+/);
      if (match) return match[0].replace(/\s/g, '');
    }
    return '$39.99';
  }

  function addSticky(details) {
    if (document.querySelector('.gpt-sticky-atc')) return;
    const normal = details.querySelector('.add-to-cart-button');
    if (!normal) return;

    const bar = document.createElement('div');
    bar.className = 'gpt-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    const price = document.createElement('div');
    price.className = 'gpt-sticky-atc__price';
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'gpt-sticky-atc__button';
    bar.append(price, button);
    document.body.append(bar);

    const sync = () => {
      price.textContent = currentPrice(details);
      button.textContent = normal.textContent.trim() || 'Add to cart';
      button.disabled = normal.disabled;
    };
    button.addEventListener('click', () => {
      sync();
      if (!normal.disabled) normal.click();
    });

    const setVisible = visible => {
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('gpt-sticky-visible', visible);
      liftPopup(visible);
    };

    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      const hasReachedDetails = window.scrollY > Math.max(250, details.offsetTop - 100);
      setVisible(!entry.isIntersecting && hasReachedDetails);
    }, { threshold: .15 });
    observer.observe(normal);
    normal.addEventListener('change', sync);
    sync();
  }

  function liftPopup(stickyVisible = document.body.classList.contains('gpt-sticky-visible')) {
    document.querySelectorAll('body *').forEach(el => {
      if (el.classList.contains('gpt-sticky-atc')) return;
      const text = (el.textContent || '').trim();
      if (!/limited\s*time\s*10%/i.test(text) || text.length > 180) return;
      const style = getComputedStyle(el);
      if (style.position === 'fixed' || style.position === 'sticky') {
        el.classList.toggle('gpt-popup-lift', stickyVisible);
      }
    });
  }

  function apply() {
    if (!media.matches) return;
    const details = document.querySelector('.product-details');
    if (!details) return;
    details.querySelectorAll('.variant-option--dropdowns, .variant-option').forEach(enhanceOption);
    moveReview(details);
    addPriceDetails(details);
    addTrust(details);
    moveAfterpay(details);
    addSticky(details);
    liftPopup();
  }

  function start() {
    apply();
    let queued = false;
    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; apply(); });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    media.addEventListener?.('change', () => location.reload());
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start)
    : start();
})();
